import { render, staticRenderFns } from "./boardEff_plot.vue?vue&type=template&id=2ea1385e&"
import script from "./boardEff_plot.vue?vue&type=script&lang=js&"
export * from "./boardEff_plot.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports